import type { SiteNavLink } from '../constants/siteNav';

interface SiteFooterNavGroupProps {
  title: string;
  links: readonly SiteNavLink[];
}

export function SiteFooterNavGroup({ title, links }: SiteFooterNavGroupProps) {
  return (
    <div className="site-footer__column">
      <p className="text-body-md text-text-quaternary">{title}</p>
      <nav className="site-footer__links">
        {links.map(({ label, href }) => (
          <a
            key={label}
            href={href}
            className="text-body-md text-text-primary transition-colors hover:text-text-secondary"
          >
            {label}
          </a>
        ))}
      </nav>
    </div>
  );
}
